/** **************************************************************************************************
 * Action Capital
 *************************************************************************************************** */
export const PAGE_REQUEST_CAPITAL = 'PAGE_REQUEST_CAPITAL';
export const SET_PERMISSION_STATE = 'SET_PERMISSION_STATE';
export const REQUEST_ALLOWED_PERMISSION = 'REQUEST_ALLOWED_PERMISSION';
export const PAGE_REQUEST_DASHBOARD = 'PAGE_REQUEST_DASHBOARD';
export const SET_DASHBOARD_LIST = 'SET_DASHBOARD_LIST';
export const PAGE_REQUEST_RESULT = 'PAGE_REQUEST_RESULT';
export const SET_APPROVAL = 'SET_APPROVAL';
export const SEND_SIGNIN_CONTRACT_CLICK = 'SEND_SIGNIN_CONTRACT_CLICK';
export const CHANGE_PAGE_APLICATION = 'CHANGE_PAGE_APLICATION';
export const SET_BORROWER_PROFILE = 'SET_BORROWER_PROFILE';
export const MOKA_CAPITAL_SET_LOAN_PERIOD = 'MOKA_CAPITAL_SET_LOAN_PERIOD';
export const MOKA_CAPITAL_ON_CLICK_APPLY_LOAN_LIST =
  'MOKA_CAPITAL_ON_CLICK_APPLY_LOAN_LIST';
export const MOKA_CAPITAL_SUBMIT_FORM_CAPITAL =
  'MOKA_CAPITAL_SUBMIT_FORM_CAPITAL';
export const MOKA_CAPITAL_SET_PAGE = 'MOKA_CAPITAL_SET_PAGE';
export const MOKA_CAPITAL_SET_ALLOW_TO_APPLY =
  'MOKA_CAPITAL_SET_ALLOW_TO_APPLY';
export const MOKA_CAPITAL_SENDING_REQUEST = 'MOKA_CAPITAL_SENDING_REQUEST';
export const SHOW_ERROR_NOTIFICATION = 'SHOW_ERROR_NOTIFICATION';
export const SET_TO_REDUCER_BY_FIELDNAME = 'SET_TO_REDUCER_BY_FIELDNAME';
export const SET_SUBMISSION_MODAL = 'SET_SUBMISSION_MODAL';
export const FAST_LOAN_SUBMISSION = 'FAST_LOAN_SUBMISSION';
export const INVESTMENT_PAGE_CHECK = 'INVESTMENT_PAGE_CHECK';
export const FAST_LOAN_SUBMIT_FORM = 'FAST_LOAN_SUBMIT_FORM';
export const SET_TENOR_DATA = 'SET_TENOR_DATA';
export const SET_PROVINCES = 'SET_PROVINCES';
export const SET_CITIES = 'SET_CITIES';
export const CHANGE_CAPITAL_TAB = 'CHANGE_CAPITAL_TAB';
export const GET_KOINWORKS_SUPPORTED_LOCATIONS =
  'GET_KOINWORKS_SUPPORTED_LOCATIONS';
export const SET_KOINWORKS_SUPPORTED_LOCATIONS =
  'SET_KOINWORKS_SUPPORTED_LOCATIONS';
export const SectionWithKoinWorksSupportedLocations = {
  BUSINESS_FORM: 'BUSINESS_FORM',
  PERSONAL_FORM: 'PERSONAL_FORM',
  CURRENT_RESIDENCE_FORM: 'CURRENT_RESIDENCE_FORM',
};
export const MOKA_CAPITAL_SUBMIT_KOINWORKSV2_FORM =
  'MOKA_CAPITAL_SUBMIT_KOINWORKSV2_FORM';
